<template lang="pug">
  form.MaterialForm.g12(onsubmit="return false" @submit="send")
    .row.col-s
      .col.g2.g6-s.mr
        label Unidade
        select(v-model="form.unidade") placeholder="Unidade" required
          option(value="") Selecione
          option(value="unitario") Unitário
          option(value="metro") Metro
      .col.g2.g6-s.mr
        label SKU
        input(v-model="form.sku" placeholder="SKU" required)
      .col.g3.g12-s.mr
        label Nome
        input(v-model="form.nome" placeholder="Nome" required)
      .col.g5.g12-s
        label Descrição
        input(v-model="form.descricao" placeholder="Descrição" required)
    .detail.row.js(v-if="form.id")
      .col
        label Criado em
        | {{form.criado_em | date}} por {{form.criado_por}}
      .col(v-if="form.alterado_em") 
        label Alterado em
        | {{form.alterado_em | date}} por {{form.alterado_por}}
    .row.js(style="margin-top: 30px")
      Button(type="submit" :loader="loader" layout="green-go") {{form.id ? "ATUALIZAR":"ADICIONAR"}}
      Button(v-if="form.id && form.status=='ativo'" @click="desativar" type="button" :loader="loader" layout="red-go") DESATIVAR
      Button(v-if="form.id && form.status=='inativo'" @click="ativar" type="button" :loader="loader" layout="green-go white") ATIVAR
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
const initForm = {
    sku: "",
    descricao: "",
    nome: "",
    unidade: ""
}
export default {
  name: "MaterialForm",
  components: { Button, Modal },
  props: { f: Object, reload: Function },
  data() {
    return {
      form: { ...initForm },
    };
  },
  beforeMount() {
    if (this.f) this.form = this.f
  },
  methods: {
    ...mapActions("admin", ["MATERIAL_NOVO", "MATERIAL_GET", "MATERIAL_UPDATE", "MATERIAL_ATIVA", "MATERIAL_DESATIVA"]),
    async send() {
      this.loader = true;
      if (this.form.id) await this.MATERIAL_UPDATE(this.form)
      else await this.MATERIAL_NOVO(this.form)
      if (!this.f) this.form = { ...initForm }
      this.file = { notallow: false, percent: 0, name: "" }
      this.reload()
      this.loader = false;
    },
    async ativar() {
      this.loader = true;
      await this.MATERIAL_ATIVA(this.form.id)
      this.reload()
      this.loader = false;
    },
    async desativar() {
      if (confirm(`Tem certeza que deseja desativar o material: ${this.form.nome}?`)) {
        this.loader = true;
        await this.MATERIAL_DESATIVA(this.form.id)
        this.reload()
        this.loader = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.MaterialForm
  @include form
  .mr
    margin-right: 3px
  
</style>
